//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, {IPromise, IWindowService} from 'angular';

export default class GoogleAnalyticsConnectionService {
  constructor(
        private $window: IWindowService,
        private AnalyticsSettingsService,
        private TrackingService,
        private ToastNotificationService,
    ) {}

  public connect(): IPromise<any> {
    return this.AnalyticsSettingsService.getGAOAuthURL().then((oauthEndpoint) => {
      if (oauthEndpoint.url) {
        this.TrackingService.recordEvent(
                    this.TrackingService.CATEGORY_SETTINGS,
                    `GA:${this.TrackingService.ACTION_CONNECT_ACCOUNT}`,
                    this.TrackingService.LABEL_SUCCESS,
                );
        this.$window.location.href = oauthEndpoint.url;
      } else {
        this.TrackingService.recordEvent(
                    this.TrackingService.CATEGORY_SETTINGS,
                    `GA:${this.TrackingService.ACTION_CONNECT_ACCOUNT}`,
                    this.TrackingService.LABEL_FAIL,
                );
        this.ToastNotificationService.error({
          title: 'An error occurred when trying to connect your Google Analytics account.',
        });
      }
    }).catch((error) => {
      this.TrackingService.recordEvent(
                this.TrackingService.CATEGORY_SETTINGS,
                `GA:${this.TrackingService.ACTION_CONNECT_ACCOUNT}`,
                this.TrackingService.LABEL_FAIL,

            );
      this.ToastNotificationService.error({
        title: error || 'An error occurred when trying to connect your Google Analytics account.',
      });
    });
  }
}

angular.module('curalate').service('GoogleAnalyticsConnectionService', [
  '$window',
  'AnalyticsSettingsService',
  'TrackingService',
  'ToastNotificationService',
  GoogleAnalyticsConnectionService,
]);
